module.exports = __webpack_public_path__ + "static/media/heart-square.71fa354b.svg";